import React, { useContext } from 'react';
import style from './style';
import i18next from 'i18next';
import TitleWithIcon from '../../../../components/common/TitleWithIcon';
import { useFormContext } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import EAAccordion from '../../../../components/EAAccordion';
import Attribute from '../../AddContext/steps/ContextAttributes/Attribute';
import ModificationDate from '../../../../components/context/ModificationDate';
import { getLatestUpdateDateFormatted } from '../../ContextDetail';
import {
  PrivilegeEnum,
  RoleBasedAccessControlContext,
} from '../../../../services/common/RolesUtils';

const AttributsBlock = ({ onEditAttribute, contextInstanceId, selectedTp }) => {
  const { classes } = style();
  const { watch } = useFormContext();
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const contextAttributes = watch('contextAttributes');
  const tiersAttributes = watch('tiersAttributes');
  const demandeAttributes = watch('demandeAttributes');

  const contextAttributesUpdateDate = getLatestUpdateDateFormatted(
    contextAttributes
  );
  const tiersAttributesUpdateDate = getLatestUpdateDateFormatted(
    tiersAttributes
  );
  const demandeAttributesUpdateDate = getLatestUpdateDateFormatted(
    demandeAttributes
  );

  return (
    <div className={classes.root}>
      <Typography variant="h3" sx={{ marginBottom: '35px' }}>
        <TitleWithIcon
          title={i18next.t(`context.contextDetail.blocks.attributs`)}
          icon={'/context/attributs_block'}
          variant={'accordion'}
          noResult={true}
        />
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {hasAnyOfPrivileges(
            PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_ATTRIBUTES
          ) && contextAttributes.length ? (
            <EAAccordion
              id={'general'}
              title={i18next.t(`context.contextDetail.attributs.contexte`)}
              logo="/context/attributs_block"
              opened={false}
              counter={contextAttributes.length}
              disabled={contextAttributes.length === 0}
              buttons={
                contextAttributesUpdateDate
                  ? [<ModificationDate date={contextAttributesUpdateDate} />]
                  : []
              }
            >
              <div className={classes.container}>
                {contextAttributes.map((contextAttribute) => (
                  <Attribute
                    contexteAttribute={contextAttribute}
                    onValidateSuccess={onEditAttribute}
                    currentValue={contextAttributes.find(
                      (c) => c.label === contextAttribute.label
                    )}
                    disabled={true}
                  />
                ))}
              </div>
            </EAAccordion>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={12}>
          {hasAnyOfPrivileges(
            PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_THIRD_PARTY_ATTRIBUTES
          ) && tiersAttributes.length ? (
            <EAAccordion
              id={'tiers'}
              title={i18next.t(`context.contextDetail.attributs.tiers`)}
              logo="/context/attributs_block"
              opened={true}
              counter={tiersAttributes.length}
              disabled={tiersAttributes.length === 0}
              buttons={
                tiersAttributesUpdateDate
                  ? [<ModificationDate date={tiersAttributesUpdateDate} />]
                  : []
              }
            >
              <div className={classes.container}>
                {tiersAttributes.map((tiersAttribute) => (
                  <Attribute
                    contexteAttribute={tiersAttribute}
                    onValidateSuccess={onEditAttribute}
                    currentValue={tiersAttributes.find(
                      (c) => c.label === tiersAttribute.label
                    )}
                    disabled={
                      selectedTp.isArchived ||
                      !hasAnyOfPrivileges(
                        PrivilegeEnum.PRIVILEGE_EDIT_CONTEXT_THIRD_PARTY_ATTRIBUTES
                      )
                    }
                  />
                ))}
              </div>
            </EAAccordion>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={12}>
          {hasAnyOfPrivileges(
            PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_THIRD_PARTY_DEMAND_ATTRIBUTES
          ) && demandeAttributes && demandeAttributes.length ? (
            <EAAccordion
              id={'declarant_attributs'}
              title={
                <>
                  <span>
                    {i18next.t(`context.contextDetail.attributs.declarant`)}
                  </span>
                </>
              }
              logo="/context/attributs_block"
              opened={false}
              counter={demandeAttributes.length}
              disabled={demandeAttributes.length === 0}
              buttons={
                demandeAttributesUpdateDate
                  ? [<ModificationDate date={demandeAttributesUpdateDate} />]
                  : []
              }
            >
              <div className={classes.container}>
                {demandeAttributes.map((demandeAttribute) => (
                  <Attribute
                    contexteAttribute={demandeAttribute}
                    onValidateSuccess={onEditAttribute}
                    currentValue={demandeAttributes.find(
                      (c) => c.label === demandeAttribute.label
                    )}
                    disabled={true}
                  />
                ))}
              </div>
            </EAAccordion>
          ): <></>}
        </Grid>
      </Grid>
    </div>
  );
};

export default AttributsBlock;
